import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const SUPABASE_URL = import.meta.env.VITE_PUBLIC_SUPABASE_URL;

  const services = [
    {
      icon: 'ri-road-map-line',
      title: 'Hormigón Impreso',
      description: 'Pavimentos decorativos con texturas y colores personalizados. Ideal para exteriores, patios y entradas.',
      link: '/proyectos?category=Hormigón%20Impreso',
      serviceLink: '/servicios/hormigon-impreso',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Impreso/photo_2026-01-27%2019.21.33.jpeg`,
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Hormigón Desactivado',
      description: 'Acabado natural con áridos vistos. Perfecto para zonas comunitarias y espacios públicos.',
      link: '/proyectos?category=Hormigón%20Desactivado',
      serviceLink: '/servicios/hormigon-desactivado',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Dezactivado/2026-01-27%2014.13.12.jpg`,
    },
    {
      icon: 'ri-contrast-line',
      title: 'Hormigón Pulido',
      description: 'Superficies lisas y brillantes para interiores modernos. Resistente y fácil de mantener.',
      link: '/proyectos?category=Hormigón%20Pulido',
      serviceLink: '/servicios/hormigon-pulido',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Pulido/photo_2026-01-27%2019.23.52.jpeg`,
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Hormigón Rallado',
      description: 'Superficie antideslizante con textura rallada. Perfecta para rampas y zonas de piscina.',
      link: '/proyectos?category=Hormigón%20Rallado',
      serviceLink: '/servicios/hormigon-rallado',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Rallado/photo_2026-01-27%2019.24.41.jpeg`,
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Piscinas Arelite',
      description: 'Revestimiento innovador para piscinas. Acabado tipo gresite con máxima durabilidad y estética.',
      link: '/proyectos?category=Piscinas%20Arelite',
      serviceLink: '/servicios/piscinas-arelite',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Arelite/2026-01-27%2012.02.07.jpg`,
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Protecciones de Acabados',
      description: 'Selladores profesionales que protegen tu inversión antes y después de cada trabajo',
      link: '/proyectos?category=Protección%20de%20Acabados',
      serviceLink: '/servicios/protecciones-acabados',
      image: `${SUPABASE_URL}/storage/v1/object/public/HormiPremium/Proteccion/2026-01-27%2018.12.03.mp4`,
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight">
            Nuestros Servicios de Hormigón Decorativo
          </h2>
          <p className="text-secondary text-lg leading-relaxed max-w-3xl mx-auto">
            Ofrecemos soluciones completas en hormigón decorativo con más de 15 años de experiencia en la Costa del Sol. Cada proyecto es único y se adapta a las necesidades específicas de nuestros clientes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="relative h-64 overflow-hidden">
                {service.image.endsWith('.mp4') ? (
                  <video
                    src={service.image}
                    className="w-full h-full object-cover object-top"
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                ) : (
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <div className="w-14 h-14 bg-primary rounded-xl flex items-center justify-center mb-3">
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-dark mb-3 group-hover:text-primary transition-colors">
                  {service.title}
                </h3>
                <p className="text-secondary text-sm leading-relaxed mb-6">
                  {service.description}
                </p>
                
                <div className="flex gap-3">
                  <Link
                    to={service.link}
                    className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-primary text-white rounded-lg font-semibold hover:bg-[#1873CC] transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-image-line"></i>
                    Ver Proyectos
                  </Link>
                  
                  <Link
                    to={service.serviceLink}
                    className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-information-line"></i>
                    Más Info
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;